export default __webpack_public_path__ + "static/media/icons8-css3.3ec32022.svg";